/**
 * Generated file, do not edit directly!
 */

/** Elevations determine the stacking order of items, the z-index. */

const Default = 'var(--dt-elevations-default, 1)';
const Sticky = 'var(--dt-elevations-sticky, 10)';
const Overlay = 'var(--dt-elevations-overlay, 20)';
const Notification = 'var(--dt-elevations-notification, 1999999999)';
export default {
  /**
   * Use as the default layer, for elements that do not need to be explicitly layered on top of other elements.
   * Css custom property: --dt-elevations-default. Value: 1.
   */
  Default,
  /**
   * Use for elements that are pinned to a certain location while also staying on top of other content.
   * Css custom property: --dt-elevations-sticky. Value: 10.
   */
  Sticky,
  /**
   * Use for elements that appear on top of all other content on the page.
   * Css custom property: --dt-elevations-overlay. Value: 20.
   */
  Overlay,
  /**
   * Use for notifications that should always be visible on top of other content.
   * Css custom property: --dt-elevations-notification. Value: 1999999999.
   */
  Notification,
};
